<template>
    <div class="expertContent">
        <div class="expertList flex">
            <div class="expertBox" v-for="(item,index) in expertData.list" :key="index">
                <div class="codeBtn">
                    <div class="expertCodeBox">
                        <el-image :src="require('@/assets/icon/triangle.png')" fit="cover" class="triangle"></el-image>
                        <!-- <div class="expertCode">
                            <el-image :src="require('@/assets/image/banner.png')" fit="cover" class="expertCodeImg"></el-image>
                            <div class="expertCodeTitle">扫码查看视频号</div>
                        </div> -->
                        <div class="expertCode">
                            <el-image :src="item.wechat" fit="cover" class="expertCodeImg"></el-image>
                            <div class="expertCodeTitle">扫码添加微信号</div>
                        </div>
                    </div>
                </div>
                <div class="expertPd">
                    <div class="align" style="padding-top: 4px;">
                        <el-image :src="item.img" fit="cover" class="head"></el-image>
                        <div class="person">
                            <div class="name">{{ item.name }}</div>
                            <div class="align">
                                <el-image :src="item.sex ? require('@/assets/icon/male.png') : require('@/assets/icon/female.png')" fit="cover" class="genderIcon"></el-image>
                                <div class="gender">{{ item.sex ? '男' : '女' }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="expertItem align">
                        <div class="title">认证:</div>
                        <div class="align">
                            <el-image :src="require('@/assets/icon/expert.png')" fit="cover" class="expertIcon"></el-image>
                            <div class="text">{{ item.type == '0' ? '品牌方' : item.type == '1' ? '服务商' :item.type == '2' ? '达人' : '' }}</div>
                        </div>
                    </div>
                    <div class="expertItem align">
                        <div class="title">联系方式:</div>
                        <div class="text">{{ item.tel }}</div>
                    </div>
                    <div class="expertItem align">
                        <div class="title">粉丝画像:</div>
                        <div class="text" :title="item.fans">{{ item.fans }}</div>
                    </div>
                    <div class="expertItem flex">
                        <div class="title">简介:</div>
                        <div class="textarea" :title="item.jianjie">{{ item.jianjie }}</div>
                    </div>
                </div>
                <div class="expertgmv">
                    <div class="gmvNum">{{ item.gmv }}</div>
                    <div class="gmvTitle">最高单场GMV</div>
                </div>
                <div class="expertPd">
                    <div class="advantageTitle">主要优势类品:</div>
                    <div class="flex">
                        <div class="advantage" v-for="(el,ii) in item.advantage" :key="ii">{{ el }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pageBox expertList">
            <el-pagination background layout="prev, pager, next" :page-size="20" :total="expertData.count" @current-change="currentPage"></el-pagination>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                userDetail: 0,
                page: 1,
                expertData: {}
            }
        },
        mounted(){
            this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
            this.getExpert()
        },
        methods: {
            // 获取列表
            getExpert(){
                this.request.get("index/daren/getlist",{
                    params:{
                        page: this.page,
                        pagesize: '20',
                        userid: this.userDetail.userid
                    }
                })
                .then(res=>{
                    this.expertData = res.data
                })
            },
            // 翻页
            currentPage(e){
                this.page = e
                this.getExpert()
            },
        }
    }
</script>
<style lang="less" scoped>
    .expertContent{
        width: 100vw;
        background: #FAFBFC;
        padding-bottom: 92px;
        .expertList{
            width: 1239px;
            margin: 0 auto;
            .expertBox{
                width: 274px;
                padding: 16px 11px;
                background: #FFFFFF;
                border: 1px solid #E1E1E6;
                border-radius: 4px;
                position: relative;
                margin: 16px 15px 0 0;
                .codeBtn{
                    width: 19px;
                    height: 19px;
                    background: url(../../assets/icon/code.png) no-repeat center/cover;
                    position: absolute;
                    top: 8px;
                    right: 8px;
                    z-index: 1;
                    cursor: pointer;
                    &:hover{
                        background: url(../../assets/icon/codeOn.png) no-repeat center/cover;
                        .expertCodeBox{
                            display: block;
                        }
                    }
                    .expertCodeBox{
                        display: none;
                        width: 140px;
                        height: 154px;
                        padding: 17px 10px;
                        background: #FFFFFF;
                        box-shadow: 0px 0px 32px 0px rgba(175,175,175,0.25);
                        border-radius: 4px;
                        position: absolute;
                        left: -140px;
                        top: 36px;
                        z-index: 2;
                        .triangle{
                            width: 23px;
                            height: 12px;
                            position: absolute;
                            left: 138px;
                            top: -12px;
                            z-index: 2;
                        }
                        .expertCode{
                            padding: 0 12px;
                            float: left;
                            .expertCodeImg{
                                width: 116px;
                                height: 116px;
                            }
                            .expertCodeTitle{
                                font: 14px/14px "Microsoft YaHei";
                                color: #FF7715;
                                padding-top: 14px;
                                text-align: center;
                            }
                        }
                    }
                }
                &:nth-child(4n){
                    margin-right: 0;
                }
                &:hover{
                    border: 1px solid #FF700B;
                }
                .expertPd{
                    padding: 0 8px;
                    .head{
                        width: 60px;
                        height: 60px;
                        border-radius: 50%;
                        border: 1px solid #FF700B;
                    }
                    .person{
                        padding-left: 17px;
                        .name{
                            width: 178px;
                            font: 16px/16px "Microsoft YaHei";
                            color: #636666;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            margin-bottom: 9px;
                        }
                        .genderIcon{
                            width: 16px;
                            height: 16px;
                        }
                        .gender{
                            font: 14px/14px "Microsoft YaHei";
                            color: #3E4040;
                            padding-left: 3px;
                        }
                    }
                    .expertItem{
                        padding-top: 16px;
                        .title{
                            font: 14px/22px "Microsoft YaHei";
                            color: #949999; 
                            padding-right: 18px;
                        }
                        .expertIcon{
                            width: 18px;
                            height: 18px;
                            margin-right: 3px;
                        }
                        .text{
                            flex: 1;
                            font: 14px/22px "Microsoft YaHei";
                            color: #3E4040;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .textarea{
                            flex: 1;
                            height: 44px;
                            font: 14px/22px "Microsoft YaHei";
                            color: #3E4040;
                            -webkit-line-clamp: 2;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }
                    .advantageTitle{
                        font: 14px/14px "Microsoft YaHei";
                        color: #949999;
                        padding-top: 15px;
                    }
                    .advantage{
                        padding: 0 6px;
                        height: 20px;
                        background: #FFF6EF;
                        border-radius: 4px;
                        font: 14px/20px "Microsoft YaHei";
                        color: #3E4040;
                        margin: 10px 10px 0 0;
                    }
                }
                .expertgmv{
                    border-top: 1px dashed #E1E1E6;
                    border-bottom: 1px dashed #E1E1E6;
                    margin-top: 13px;
                    padding: 20px 0;
                    .gmvNum{
                        font: 28px/28px "Microsoft YaHei";
                        color: #3A3A3A;
                        text-align: center;
                    }
                    .gmvTitle{
                        font: 14px/14px "Microsoft YaHei";
                        color: #FF6C04;
                        text-align: center;
                        padding-top: 12px;
                    }
                }
            }
        }
    }
</style>